import { PluginFunction } from 'vue';
import { formatNumber, formatRoundedNumber } from '@/helpers/numbers';

export const Numbers: PluginFunction<any> = (Vue) => {
	Vue.filter('number', formatNumber);
	Vue.filter('roundedNumber', formatRoundedNumber);
	Vue.mixin({
		methods: {
			formatNumber,
			formatRoundedNumber,
		}
	});
}

declare module "vue/types/vue" {
	interface Vue {
		formatNumber: typeof formatNumber;
		formatRoundedNumber: typeof formatRoundedNumber;
	}
}
